// Store
import store from "@/store/index";

export interface CoachPlayersProfileTrainingsListFormCreate {
  user_id: string | string[];
  organization_id: string;
  training_category_id: string;
  content: {
    date: string;
    fields: any;
  };
}

export class CoachPlayersProfileTrainingsListFormCreate implements CoachPlayersProfileTrainingsListFormCreate {
  user_id: string | string[];
  organization_id: string;
  training_category_id: string;
  content: {
    date: string;
    fields: any;
  };

  constructor() {
    this.user_id = "";
    this.organization_id = store.getters.getOrganizationMember.organization_id ?? "";
    this.training_category_id = "";
    this.content = {
      date: "",
      fields: [],
    };
  }
}